import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

const topLink = [
    { id: 1, link: '/online-service', name: 'online_services' },
    { id: 2, link: '/law-help', name: 'law_help' },
    { id: 3, link: '/state-duty', name: 'state_duty' },
]

const ServicesLayout = () => {
    const { t } = useTranslation()
    const location = useLocation();
    
    return (
        <div className='mt-8 flex justify-center media'>
            <ul className='md:flex md:flex-wrap gap-3 bg-white 
                           justify-center w-full p-4 xl:p-8  text-[14px]
                           dark:text-dark-text dark:bg-dark-box'>
                {topLink?.map((d) => (
                    <Link
                        to={d.link}
                        key={d.id}
                        className={`relative group 
                        ${location.pathname === d.link ? 'text-primary dark:text-white'
                                                       : 'text-black dark:text-dark-text'}
                `}
                    >
                        <li className={`relative p-4 after:content-[''] 
                                        after:absolute after:left-0 after:bottom-0 
                                        after:h-[1.5px] after:bg-primary  after:w-0 
                                        after:transition-all after:duration-500 
                                        group-hover:after:w-full bg-blue
                                        dark:bg-dark shadow mb-2 xl:mb-0                             
                            ${location.pathname === d.link ? 'after:w-0' : ''}
                        `}>
                            {t(d.name)}
                        </li>
                    </Link>
                ))}
            </ul>
        </div>
    )
}

export default ServicesLayout